module.exports = __webpack_public_path__ + "img/benefit-card-3-tablet.3254c66e.png";